import { Component } from '@angular/core';

@Component({
  selector: 'psc-transactions',
  templateUrl: './transactions.component.html'
})
export class TransactionsComponent {

}
